import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--gap);
  background: rgba(123, 225, 254, 0.2);
  border: 1px solid var(--secondary-dark);
  border-radius: var(--border-radius);
  text-align: center;
  gap: 8px;
`;

export const Text = styled.p`
  margin: 0;
  color: var(--secondary-dark);
`;

export const ButtonWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: -8px;
`;
